var $ = require('jquery');
var _ = require('underscore');
var Configuration = EY.Consultation.Lookups.Configuration;
var Labels = EY.Consultation.Labels;
var RecordDocumentationSync = require('RecordDocumentationSync');
var RecordType = EY.Consultation.Lookups.RecordType;
var toBeNotified = [
    'SubCountryProfessionalPractice',
    'CountryProfessionalPractice',
    'RegionalProfessionalPractice',
    'RequiredNotification'
];

//RequiredNotification has a special validation - Apart from EQR, at least one to be notified role should be filled.
//This means that CPP/RPP/RN - among these at least one should be present.
var rn = function (options) {
    var approvers = options.approvers;
    var record = options.record;
    var groups = options.groups;
    var valid = true;
    var allRNValid = true;
    var upn;
    var rank;
    var group;
    var isEmpty;
    var isFilled;
    
    if (record.get('recordTypeId') === RecordType.RequiredNotification) {
        valid = false;

        //1. Check if at lease one of the designated toBeNotified have value
        approvers.each(function (approver) {
            group = approver.get('approverGroupId');
            upn = approver.get('upn');
            rank = approver.get('rank');

            if (toBeNotified.includes(group) && !valid) {

                valid = group === 'RequiredNotification' ? (!!upn && !!rank) : !!upn;
            }
        });

        //2. Check if all RN are valid - (This is true when all RNs have either both UPN and Rank or neither UPN nor Rank)
        var allRN = approvers.where({ approverGroupId: 'RequiredNotification' });

        _.each(allRN, function (rn) {

            upn = rn.get('upn');
            rank = rn.get('rank');
            isEmpty = !upn && !rank;
            isFilled = !!upn && !!rank;

            allRNValid = allRNValid && (isFilled || isEmpty);
        });

        //3. Validate all the required approvers which need to be notified.
        // Remove error and class if all RNs are valid and at least one designated role has value.
        approvers.each(function (approver) {
            var group = approver.get('approverGroupId');
            var required = groups.get(group).get('required');

            if (toBeNotified.includes(group)) {

                required && approver.isValid(true);

                if (valid && allRNValid) {

                    approver.associatedViews[0].$el.parent().next('section').addClass('hidden');
                    approver.associatedViews[0].$el.parent('div').removeClass('required');
                }
            }
        });
    }
    return valid && allRNValid;
}

var validate = function (options) {
    var approvers = options.approvers;
    var deferred = $.Deferred();
    var fields = options.fields;
    var grouped = _.groupBy(approvers.toJSON(), 'approverGroupId');
    var groups = options.groups;
    var promise = deferred.promise();
    var record = options.record;
    var valid = record.isValid(true);
    var isRecordTypeRN = record.get('recordTypeId') === RecordType.RequiredNotification;

    approvers.clone().each(function (approver) {
        var group = approver.get('approverGroupId');
        var required = groups.get(group).get('required');
        var upn = approver.get('upn');

        // If one approver exists at this level; and this is not the first approver at the level then remove it if no upn is provided.
        //Skip validation if RecordType = RequiredNotification and role is one of to be notified (as this validation is covered in rn function)
        if (!upn && grouped[group].length > 1 && approver.id !== _.chain(grouped[group]).sortBy('order').first().value().id) {
            approvers.remove(approver);
            approver.trigger('change');
        } else if ((required || upn || approver.get('rank')) && ((!toBeNotified.includes(group) && isRecordTypeRN) || !isRecordTypeRN) && !approver.isValid(true)) {
            valid = false;
        }
    });

    valid = rn(options) && valid;

    fields.each(function (field) {
        valid = field.isValid(true) ? valid : false;
    });
    if (!valid) {
        var $control = $('.required').first();

        if ($control.length && !$control.isInViewport()) {
            $control.parent().children(':first-child').get(0).scrollIntoView();
            $('html').scrollLeft(0);
            $('.record-scroll').scrollLeft(0)
        }
        !!Configuration.EnableSaveMessage && record.trigger('save-fail');
    }
    RecordDocumentationSync.start(options).done(function () {
        var oversize = options.attachments.findWhere(function (attachment) { return attachment.get('filelength') > Configuration.DocumentSize; });
        var sized = Configuration.MaxDocumentSize >= options.attachments.reduce(function (memo, model) {
            return memo + model.get('filelength');
        }, 0);
        deferred.resolve(valid && !oversize && sized, oversize ? Labels.MaxSizePerFile : (!sized ? Labels.MaxTotalAttachmentSize : '')); // attachment size limit validation
    });
    return promise;
};

module.exports.run = function (options) {
    return validate(options);
};


// WEBPACK FOOTER //
// ./js/Modules/Record/Service/RecordValidation.js